import React from 'react';
import ValidationType from '../../Model/ValidationType';
import '../FormComponents.scss'

export interface IErrorMessageProps {
    Label?: string;
    FieldName: string;
    ValidationAndEvent?: ValidationType;
    errors: any;
    message?: string;
    ignoreLabel?: boolean;
    invalidCustomField?:boolean;
    requiredMessage?:string;
}
const ErrorMessage: React.FC<IErrorMessageProps> = (props) => {

    const renderError = () => {       
        if(props.errors[props.FieldName]?.types?.required ){           
            return (
            <span>{props.errors[props.FieldName].types.required}</span>
            )
        }
        else if(props.errors[props.FieldName]?.types?.pattern ){           
            return (
            <span>{props.errors[props.FieldName].types.pattern}</span>
            )
        }
        else if(props.invalidCustomField == true && props.message){
            return(
            <span>{props.message}</span>
            )
        }
        else if(props.ValidationAndEvent && props.ValidationAndEvent.required && props.errors[props.FieldName]?.type == "required" || props.invalidCustomField == true) {

            return (
                <span>{((props.ignoreLabel && props.ignoreLabel == true) || props.invalidCustomField == true ) == true? (<span>{(props.requiredMessage)? props.requiredMessage: "Required"}</span>):(null)}
                    {(props.ignoreLabel == undefined || !props.ignoreLabel) == true ? (<span>{props.Label} required.</span>) : (null)}
                </span>
            )
        }
        else if (props.ValidationAndEvent && props.ValidationAndEvent.maxLength && props.errors[props.FieldName]?.type == "maxLength") {
            return (
                <span>{props.ignoreLabel && props.ignoreLabel == true && <span>Should be less than {props.ValidationAndEvent.maxLength} charaters</span>}
                    {(props.ignoreLabel == undefined || !props.ignoreLabel) == true ? (<span>{props.Label} should be less than {props.ValidationAndEvent.maxLength} charaters</span>) : (null)}
                </span>
            )
        }
        else if (props.ValidationAndEvent && props.ValidationAndEvent.pattern && props.errors[props.FieldName]?.type == "pattern") {
            return (<span>{props.Label} {props.message}</span>)
        }
    }

    return (
        <div className="text-danger error-message">
            {renderError()}
        </div>
    )
}

export default ErrorMessage;